
// FontAwesome 5 - https://fontawesome.com/
import "@fortawesome/fontawesome-pro/css/all.css";
import "slick-carousel/slick/slick.scss";
import "slick-carousel/slick/slick-theme.scss";
import 'lightgallery/src/sass/lightgallery.scss';

import 'bootstrap';
import 'slick-carousel';

import basicNavigation from './header/header';
import inlineSVG from './utilities/convert-svg-to-html';
import 'lightgallery';
import 'lg-thumbnail';
import 'lg-video';
import 'waypoints/lib/noframework.waypoints.min.js';
import CustomMarker from './branch-contact';

import Swiper, {Autoplay} from 'swiper';
// import { Navigation, Pagination} from 'swiper/modules';
Swiper.use([Autoplay]);


import Instafeed from 'instafeed.js';
import detectIE from "./utilities/detectIE";

window.Instafeed = Instafeed;


var is_safari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

//removing fade for safari
if (!is_safari) {
    $(window).on('load', function(){
        $("body .page-transition").css('z-index', '9999').animate({ opacity: 0 }, 200);
        setTimeout(function(){
            $("body .page-transition").css('z-index', '0');
        }, 700);
    });
} else {
    $('.page-transition').css('display', 'none');
}

$('.alert .close').on('click', function(){
    $('.alert').addClass('d-none');
});

// Catch all anchor clicks bubbled to the document...
$(document).on('click', "a", function(event) {
    event.preventDefault();
    var anchor = $(this);
    var linkLocation = this.href;

    // DON'T FADE FOR LINKS THAT OPEN IN NEW WINDOW
    if ( anchor.attr('target') && anchor.attr('target').indexOf('_blank') >=0 ) {
        window.open(linkLocation,'_blank');
        return false;
    }

    // DON'T FADE FOR EMAIL
    if ( anchor.attr('href').indexOf('mailto:') >=0 ) {
        var email = anchor.attr('href').slice(7);
        window.location = 'mailto:' + email;
        return false;
    }

    // DON'T FADE FOR TELEPHONE LINKS
    if ( anchor.attr('href').indexOf('tel:') >=0 ) {
        var phone = anchor.attr('href').slice(4);
        window.location = 'tel:' + phone;
        return false;
    }

    // DON'T FADE FOR LINKS TO ANCHOR TAGS
    if ( anchor.attr('href').indexOf('#') >=0 )
        return;

    // DON'T FADE FOR Hail gallery
    if ( anchor.hasClass('lightgallery-item') )
        return;

    //removing fade for safari
    if (is_safari) {
        setTimeout(function(){
            $("body").removeClass('nav-is-open');
        }, 500);
        redirectPage(linkLocation);
    } else {
        $("body .page-transition").css('z-index', '9999').animate({opacity: 1}, 200);
        setTimeout(function(){
            redirectPage(linkLocation);
        }, 200);
    }
});

function redirectPage(link) {
    document.location.href = link;
}

$(document).ready(function(){

    let branch_ph = $('.contact-box .branch-info #branch-phone-link').text();
    $(".header-phone-inner").each(function() {
        $(this).text(branch_ph);
        let tel = 'tel:' + branch_ph;
        let onclick = "return gtag_report_conversion('" + tel + "');";
        $(this).attr('href', tel);
        $(this).attr('onclick', onclick);
    });

    console.log();
    // Add smooth scrolling on all links inside the navbar
    $(".service-anchors a").on('click', function(event) {
        // Make sure this.hash has a value before overriding default behavior
        console.log(this.hash);
        if (this.hash !== "") {
            // Prevent default anchor click behavior
            event.preventDefault();
            // Store hash
            var hash = this.hash;
            // Using jQuery's animate() method to add smooth page scroll
            $('html, body').animate({
                scrollTop: $(hash).offset().top - 80
            }, 800, function(){

            });
        } // End if
    });

    $('#regionSelect').change(function(){
        var value = $(this).val();
        $('.single-region').addClass('d-none').removeClass('first-region last-region');
        $("#regionList .single-region").each(function(i) {
            var region = $(this).attr('data-region');
            if ( value === region ) {
                $(this).removeClass('d-none');
                $('#regionTitle').text(value.toString());
            } else if (value === 'All') {
                $('.single-region').removeClass('d-none');
                $('#regionTitle').text('Find a local trade expert');
            }
            else {
                $(this).addClass('d-none');
            }
        });
    });

    var filterbtn = '';
    var regionfilter = '';
    var mapfilter = '';
    //filter clicks
    $('.filter-btn').on("click", function(){
        $('.single-region').addClass('d-none');
        var btnclicked = $(this).attr('data-attr');
        filterbtn = btnclicked;
        $('.filter-btn').removeClass('active-filter');
        $(this).addClass('active-filter');
        MasterFilter();
    });

    if ($('html').hasClass('touch')) {
        console.log('ismobile');
    } else {
        var description = $(".SVGMapDescription");

        $('#map g').hover(function() {
            description.addClass('active');
            description.html($(this).attr('id').slice(0,-3).replace(/_/g, ' '));
            $('.SVGMapDescriptionLoad').css('display', 'none');
            $('#map g').removeClass('load-active');
        }, function() {
            description.removeClass('active');
        });

        $(document).on('mousemove', function(e){
            description.css({
                left:  e.pageX,
                top:   e.pageY - 70
            });
        });

        $('#map g').on("click", function(){
            ClearFilters();
            var mapsection = $(this);
            mapsection.addClass('active');
            $("#map g").each(function(i) {
                $(this).removeClass('active');
            });
            mapsection.addClass('active');
            $('.single-region').addClass('d-none').removeClass('first-region last-region');
            var currentRegion = $(this).prop('id').slice(0,-3).replace(/_/g, ' ');
            mapfilter = currentRegion;
            MasterFilter();
        });
    }

    //map search
    $("#locationFilter").keyup(function() {
        ClearFilters();
        $('#regionList .single-region').show().removeClass('d-none');
        $('#map g').removeClass('active');
        $('.filter-btn').removeClass('active-filter');
        // Retrieve the input field text and reset the count to zero
        regionfilter = $(this).val();

        // Loop through the comment list
        MasterFilter();
    });
    $('#map g').on('click', function(){
        $('#regionList .single-region').show();
        $('#locationFilter').val('');
        $('.filter-btn').removeClass('active-filter');
        filterbtn = '';
    });
    $('#resetRegions').on('click', function(){
        $('#regionList .single-region').show().removeClass('d-none');
        $('#map g').removeClass('active');
        $('#locationFilter').val('');
        $('.filter-btn').removeClass('active-filter');
        ClearFilters();
    });

    function MasterFilter() {
        var count = 0;
        var filter = regionfilter;
        var currentRegion = mapfilter;
        $('#regionList .single-region').each(function() {
            // If the list item does not contain the text phrase fade it out
            if ($(this).text().search(new RegExp(filter, "i")) < 0) {
                $(this).hide().addClass('d-none');
                // Show the list item if the phrase matches and increase the count by 1
            } else {
                $(this).show().removeClass('d-none');
                count++;
                if (filterbtn.length > 0 || mapfilter.length > 0) {
                    if (filterbtn.length > 0 ) {
                        if (!$(this).hasClass(filterbtn)) {
                            $(this).addClass('d-none');
                        }
                    }
                    if (mapfilter.length > 0) {
                        var region = $(this).attr('data-region');
                        if ( currentRegion !== region ) {
                            $(this).addClass('d-none');
                        }
                    }
                }
            }
        });
        CheckAllHidden();
    }

    function ClearFilters() {
        mapfilter = '';
        filterbtn = '';
        regionfilter = '';
    }

    function CheckAllHidden() {
        var regionvisible = false;
        $("#regionList .single-region").each(function(i) {
            if (!$(this).hasClass('d-none')) {
                regionvisible = true;
            }
        });
        if (!regionvisible) {
            $('#emptyRegion').removeClass('d-none');
        } else {
            $('#emptyRegion').addClass('d-none');
        }
    }

    //set dropdown on contact from branch page link
    $.urlParam = function(name){
        var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
        if (results==null) {
            return null;
        }
        return decodeURI(results[1]) || 0;
    }
    var location = decodeURIComponent($.urlParam('branch'));
    $('#NationalContactForm_Form_Region option[value="' + location + '"]').prop("selected", "selected");

    setTimeout(function(){
        $('.title-image-inner').addClass('small-image');
    }, 300);

    /*
    header that hides on scroll down
    var c, currentScrollTop = 0,
        navbar = $('.header-nav');

    $(window).scroll(function () {
        var a = $(window).scrollTop();
        var b = navbar.height();

        currentScrollTop = a;

        if (c < currentScrollTop && a > b + b) {
            navbar.addClass("scrollUp");
        } else if (c > currentScrollTop && !(a <= b)) {
            navbar.removeClass("scrollUp");
        }
        c = currentScrollTop;
    });*/

    //slick slider on branch pages for staff
    $('.branch-slick').slick({
        autoplaySpeed: 7000,
        slidesToShow: 1,
        slidesToScroll: 1,
        draggable: false,
        autoplay: true,
        dots: false,
        arrows: true,
        prevArrow: $('.prev-arrow'),
        nextArrow: $('.next-arrow')
    });

    let slideCount = $('#service-count').data('service-count');
    let swiper = new Swiper(".service-container", {
        loop: true,
        freeMode: true,
        allowTouchMove: false,
        speed: 5000,
        freeModeMomentum: false,
        autoplay: {
            delay: 1,
            disableOnInteraction: false
        },
        // slidesPerView: slideCount / 2,
        breakpoints: {
            320: {
                slidesPerView: 4
            },
            640: {
                slidesPerView: 6
            },
            768: {
                slidesPerView: 8
            },
            991: {
                slidesPerView: 10
            },
            1199: {
                slidesPerView: 12
            },
        }
    });
    $(".cd-nav-trigger").click(function(){

        if($('body').hasClass('nav-is-open')) {
            $('.service-container').css('z-index', '0');
            $('.service-container').css('position', 'unset');
        } else {
            $('.service-container').css('z-index', '10');
            $('.service-container').css('position', 'fixed');
        }
    });

        //map on branch page with pin drop animation
    if ( $("#branch-map").length ) {
        var pos = new google.maps.LatLng(gmapLatitude, gmapLongitude);
        var center = new google.maps.LatLng(gmapLatitude + 0.002, gmapLongitude);
        var map = new google.maps.Map(document.getElementById('branch-map'), {
            zoom: gmapZoom,
            center: center,
            disableDefaultUI: false,
            scrollwheel: false,
            draggable: true,
            styles: [{
                "featureType": "landscape",
                "elementType": "all",
                "stylers": [{"hue": "#ff2900"}, {"gamma": 1}]
            }, {
                "featureType": "poi",
                "elementType": "all",
                "stylers": [{"saturation": 33.4}, {"lightness": -25.4}, {"gamma": 1}, {"color": "#638a6c"}, {"weight": "0.72"}]
            }, {
                "featureType": "poi",
                "elementType": "geometry",
                "stylers": [{"color": "#c3e9d5"}, {"lightness": "0"}, {"saturation": "-1"}, {"gamma": "1.07"}]
            }, {
                "featureType": "poi",
                "elementType": "labels",
                "stylers": [{"color": "#7e7e7e"}, {"weight": "0.93"}]
            }, {
                "featureType": "poi",
                "elementType": "labels.text.stroke",
                "stylers": [{"weight": "0.72"}]
            }, {
                "featureType": "road.highway",
                "elementType": "all",
                "stylers": [{"hue": "#53FF00"}, {"saturation": -73}, {"lightness": 40}, {"gamma": 1}]
            }, {
                "featureType": "road.arterial",
                "elementType": "all",
                "stylers": [{"hue": "#FBFF00"}, {"gamma": 1}]
            }, {
                "featureType": "road.local",
                "elementType": "all",
                "stylers": [{"hue": "#00FFFD"}, {"lightness": 30}, {"gamma": 1}]
            }, {
                "featureType": "water",
                "elementType": "all",
                "stylers": [{"hue": "#008cff"}, {"saturation": "17"}, {"lightness": 8}, {"gamma": 1}]
            }]
        });

        var marker = new CustomMarker('branch-map', {
            position: pos,
            map: map,
        });

        if ((typeof(gmapLatitude2) != "undefined" && gmapLatitude2 !== null) && (typeof(gmapLongitude2) != "undefined" && gmapLongitude2 !== null)) {
            var pos2 = new google.maps.LatLng(gmapLatitude2, gmapLongitude2);
            var marker2 = new CustomMarker('branch-map', {
                position: pos2,
                map: map,
            });

            var centeredgmapLatitude = gmapLatitude - 0.005;
            var centeredgmapLatitude2 = gmapLatitude2 + 0.01;

            if (gmapLatitude > gmapLatitude2) {
                centeredgmapLatitude = gmapLatitude + 0.01;
                centeredgmapLatitude2 = gmapLatitude2 - 0.005;
            }
            var defaultBounds = new google.maps.LatLngBounds(
                new google.maps.LatLng(centeredgmapLatitude, gmapLongitude),
                new google.maps.LatLng(centeredgmapLatitude2, gmapLongitude2)
            );
            map.fitBounds(defaultBounds);

        } else {
                $(window).resize(function () {
                    map.panTo(pos);
                });
            }

        if ((typeof(gmapLatitude3) != "undefined" && gmapLatitude3 !== null) && (typeof(gmapLongitude3) != "undefined" && gmapLongitude3 !== null)) {
            var pos3 = new google.maps.LatLng(gmapLatitude3, gmapLongitude3);
            var marker3 = new CustomMarker('branch-map', {
                position: pos3,
                map: map,
            });

            var centeredgmapLatitude = gmapLatitude - 0.005;
            var centeredgmapLatitude3 = gmapLatitude3 + 0.01;

            if (gmapLatitude > gmapLatitude3) {
                centeredgmapLatitude = gmapLatitude + 0.01;
                centeredgmapLatitude3 = gmapLatitude3 - 0.005;
            }
            var defaultBounds = new google.maps.LatLngBounds(
                new google.maps.LatLng(centeredgmapLatitude, gmapLongitude),
                new google.maps.LatLng(centeredgmapLatitude3, gmapLongitude3)
            );
            map.fitBounds(defaultBounds);

        } else {
                $(window).resize(function () {
                    map.panTo(pos);
                });
            }

        if (!detectIE()) {
            google.maps.event.addListenerOnce(map, 'tilesloaded', function(){
                inView('#branch-map')
                    .on('enter', el => {
                        marker.animateDrop();
                        if(marker2){marker2.animateDrop();}
                        if(marker3){marker3.animateDrop();}
                    });
            });
        }


    }

    //showing video after page loads
    setTimeout(function(){
        $('.video-wrapper').removeClass('video-hidden');
        $('.video-overlay').addClass('overlay-show');
    }, 2000);

    if ($('#aoteaVideo').length > 0) {
        setTimeout(function(){
            $('#aoteaVideo')[0].play();
        }, 1800);
    }

    setTimeout(function(){
        $('.video-wrapper h2').addClass('show-text animated fadeInUp');
    }, 2500);

});

$(function () {
    //home page case study parallax
    if ( $(".parallax").length > 0 ) {
        inView('.parallax')
            .on('enter', el => {
                var parallaxElements = $('.parallax'),
                    parallaxQuantity = parallaxElements.length;
                $(window).on('scroll', function () {
                    window.requestAnimationFrame(function () {
                        for (var i = 0; i < parallaxQuantity; i++) {
                            var currentElement = parallaxElements.eq(i);
                            var scrolled = $(document).scrollTop() - $("#intro").offset().top;
                            currentElement.css({
                                'transform': 'translate3d(0,' + scrolled * -0.08 + 'px, 0)'
                            });
                        }
                    });
                });
            });
    }

    //branch page case study parallax
    if ( $(".parallax2").length > 0 ) {
        inView('.parallax2')
            .on('enter', el => {
                var parallaxElements = $('.parallax2'),
                    parallaxQuantity = parallaxElements.length;
                $(window).on('scroll', function () {
                    window.requestAnimationFrame(function () {
                        for (var i = 0; i < parallaxQuantity; i++) {
                            var currentElement =  parallaxElements.eq(i);
                            var scrolled = $(window).scrollTop();
                            currentElement.css({
                                '-webkit-transform': 'translate3d(0,' + scrolled * -0.12 + 'px, 0)',
                                '-moz-transform': 'translate3d(0,' + scrolled * -0.12 + 'px, 0)',
                                '-ms-transform': 'translate3d(0,' + scrolled * -0.12 + 'px, 0)',
                                'transform': 'translate3d(0,' + scrolled * -0.12 + 'px, 0)'
                            });
                        }
                    });
                });
            });
    }

    //case studies stats box scroll movement
    $('.stat-section .box-image').css('transform', 'translateY(-70px)').css('opacity', '0');
    $('.stat-section .box-content').css('transform', 'translateY(70px)').css('opacity', '0');
    inView('.stat-section')
        .on('enter', el => {
            var parallaxElements1 = $('.stat-section .box-image'),
                parallaxQuantity1 = parallaxElements1.length;
            var parallaxElements2 = $('.stat-section .stat-content'),
                parallaxQuantity2 = parallaxElements2.length;
            $('.stat-section .box-image').animate({ opacity: 1 });
            $('.stat-section .box-content').animate({ opacity: 1 });
            $(window).on('scroll', function () {
                window.requestAnimationFrame(function () {
                    for (var i = 0; i < parallaxQuantity1; i++) {
                        var currentElement1 = parallaxElements1.eq(i);
                        var scrolled1 = $(document).scrollTop() - $(".stat-section").offset().top;
                        currentElement1.css({
                            'transform': 'translate3d(0,' + scrolled1 * +0.06 + 'px, 0)'
                        });
                    }
                    for (var j = 0; j < parallaxQuantity2; j++) {
                        var currentElement2 = parallaxElements2.eq(j);
                        var scrolled2 = $(document).scrollTop() - $(".stat-section").offset().top;
                        currentElement2.css({
                            'transform': 'translate3d(0,' + scrolled2 * -0.06 + 'px, 0)'
                        });
                    }
                });
            });
        });

    //branch page box scroll movement
    $(window).on('load resize', function () {
        if ($(window).width() > 991) {
            $('.contact-box').css('transform', 'translateY(-70px)');
            inView('.branch-contact')
                .on('enter', el => {
                    var parallaxElements = $('.branch-contact .contact-box'),
                        parallaxQuantity = parallaxElements.length;
                    $(window).on('scroll', function () {
                        window.requestAnimationFrame(function () {
                            for (var i = 0; i < parallaxQuantity; i++) {
                                var currentElement = parallaxElements.eq(i);
                                var scrolled = $(document).scrollTop() - $(".branch-contact").offset().top;
                                currentElement.css({
                                    'transform': 'translate3d(0,' + scrolled * +0.06 + 'px, 0)'
                                });
                            }
                        });
                    });
                });
        }
        //setting top home content offset top
        var videoHeight = $('#aoteaVideo').outerHeight();
        $('.home-page-wrapper').css('margin-top', (videoHeight + 70) + 'px');
    });

    $(window).on('load', function () {
        if (typeof($.urlParam('region')) !== 'undefined') {
            var passRegion = decodeURIComponent($.urlParam('region'));
            var mapregion = passRegion.replace(/ /g, '_') + '_1_';
            if(window.location.href.indexOf("?region=") > -1) {
                $("#regionList .single-region").each(function (i) {
                    var region = $(this).attr('data-region');
                    if (passRegion === region) {
                        $(this).removeClass('d-none');
                    } else {
                        $(this).addClass('d-none');
                    }
                });
                $("#map g").each(function(i) {
                    var region = $(this).attr('id');
                    if(mapregion == region) {
                        $(this).addClass('active');
                    }
                });
            }
        }
    });

    $(window).on('load resize', function () {
        //service boxes
        var thirdwindow = $(window).width() / 3;
        var halvewindow = $(window).width() / 2;
        if ($(window).width() > 991) {
            $('.service-box-intro').css('min-height', thirdwindow + 'px');
            $('.service-box-content').css('min-height', thirdwindow + 'px');
            $('.service-box-image').css('min-height', thirdwindow + 'px');
            $('.service-box-intro').removeClass('order-1 order-sm-1 order-md-1');
            $('.service-box-content').removeClass('order-2 order-sm-2 order-md-2');
            $('.service-box-image').removeClass('order-3 order-sm-3 order-md-3');
        } else {
            $('.service-box-intro').addClass('order-1 order-sm-1 order-md-1');
            $('.service-box-content').addClass('order-2 order-sm-2 order-md-2');
            $('.service-box-image').addClass('order-3 order-sm-3 order-md-3');
        }

        //home page block half screen size
        var halfwindow = ($(window).width() - 60) / 2;
        $('.home-block').css('height', halfwindow + 'px');

        //national case studies block fade in up
        if ($(window).width() > 768) {
            (function($) {
                $.fn.visible = function(partial) {

                    var $t            = $(this),
                        $w            = $(window),
                        viewTop       = $w.scrollTop(),
                        viewBottom    = viewTop + $w.height(),
                        _top          = $t.offset().top,
                        _bottom       = _top + $t.height(),
                        compareTop    = partial === true ? _bottom : _top,
                        compareBottom = partial === true ? _top : _bottom;

                    return ((compareBottom <= viewBottom) && (compareTop >= viewTop));
                };
            })(jQuery);

            var win = $(window);
            var allMods = $(".module");
            allMods.each(function(i, el) {
                var el = $(el);
                if (el.visible(true)) {
                    el.addClass("already-visible");
                }
            });

            win.scroll(function(event) {
                allMods.each(function(i, el) {
                    var el = $(el);
                    if (el.visible(true)) {
                        el.addClass("come-in");
                    }
                });
            });
        }
    });

    basicNavigation();

    inlineSVG('.navbar-logo, .footer-logo, .admin-logo');

    $('.lightgallery').lightGallery({
        selector: '.lightgallery-item',
        thumbnail: true
    });

    $('.slick-casestudies').on('init', function(e, slick) {
        var $firstAnimatingElements = $('div.slick-casestudy-inner:first-child').find('[data-animation]');
        doAnimations($firstAnimatingElements);
    });
    $('.slick-casestudies').on('beforeChange', function(e, slick, currentSlide, nextSlide) {
        var $animatingElements = $('div.slick-slide[data-slick-index="' + nextSlide + '"]').find('[data-animation]');
        doAnimations($animatingElements);
    });
    $('.slick-casestudies').slick({
        autoplay: true,
        autoplaySpeed: 70000,
        fade: true,
        pauseOnHover:false,
        nextArrow: '.cs-next',
        prevArrow: '.cs-prev'
    });
    function doAnimations(elements) {
        var animationEndEvents = 'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend';
        elements.each(function() {
            var $this = $(this);
            var $animationDelay = $this.data('delay');
            var $animationType = 'animated ' + $this.data('animation');
            $this.css({
                'animation-delay': $animationDelay,
                '-webkit-animation-delay': $animationDelay
            });
            $this.addClass($animationType).one(animationEndEvents, function() {
                $this.removeClass($animationType);
            });
        });
    }

    $('.branch-casestudies').slick({
        autoplay: true,
        autoplaySpeed: 10000,
        fade: true,
        pauseOnHover:false,
        arrows: true,
        nextArrow: '.cs-next',
        adaptiveHeight: true
    });

    $('.branch-testimonials').slick({
        autoplay: true,
        autoplaySpeed: 7000,
        fade: true,
        pauseOnHover:false,
        arrows: true,
        nextArrow: '.testimonial-next',
        prevArrow: '.testimonial-prev',
        adaptiveHeight: true
    });


    $('.elemental-sponsors .slick').slick({
        slidesToShow: 5,
        arrows: false,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    arrows: false,
                    slidesToShow: 5
                }
            },
            {
                breakpoint: 992,
                settings: {
                    arrows: false,
                    slidesToShow: 4
                }
            },
            {
                breakpoint: 768,
                settings: {
                    arrows: false,
                    slidesToShow: 2
                }
            }
        ]
    });

    $('.hail-carousel').each(function(index, element){
        //Build carousel options (from the Hail carousel DataObject)
        const slickOptions = {
            arrows: false,
            centerPadding: '0px',
            lazyLoad: 'ondemand',
            autoplay: true,
            autoplaySpeed: 3000,
            cssEase: 'ease-in-out',
            dots: ($(element).data('showdots') === "Yes"),
            slidesToShow: $(element).data('lg-toshow'),
            slidesToScroll: $(element).data('lg-toscroll'),
            responsive: [
                {
                    breakpoint: $(element).data('md-break'),
                    settings: {
                        slidesToShow: $(element).data('md-toshow'),
                        slidesToScroll: $(element).data('md-toscroll')
                    }
                },
                {
                    breakpoint: $(element).data('sm-break'),
                    settings: {
                        slidesToShow: $(element).data('sm-toshow'),
                        slidesToScroll: $(element).data('sm-toscroll'),
                        arrows: false
                    }
                }
            ]
        };

        $(element).slick(slickOptions);
    });

    if (detectIE()) {
        $('#branch-map').addClass('ie-map');
        $('.js .cd-nav').css('z-index', '5');
    }

});

